import { IRetentionStyle } from '../types';
import { theme } from '../../../../styles/theme';

// https://colordesigner.io/gradient-generator
export const retentionCellStyle: IRetentionStyle[] = [
  {
    backgroundColor: theme.colors.level2,
    foregroundColor: theme.colors.secondary800,
    liveIconKey: 'colored-orange-circles',
  },
  {
    backgroundColor: '#e6f1fd',
    foregroundColor: '#626266',
    liveIconKey: 'colored-orange-circles',
  },
  {
    backgroundColor: '#cce3fb',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#b3d6f9',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#99c8f7',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#80baf4',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#66acf2',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#4d9ef0',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#3391ee',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#1a83ec',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: theme.colors.mainBlue,
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
];

export const churnCellStyle: IRetentionStyle[] = [
  {
    backgroundColor: 'transparent',
    foregroundColor: '#B2000C',
    liveIconKey: 'colored-orange-circles',
  },
  {
    backgroundColor: '#F7E5E6',
    foregroundColor: '#B2000C',
    liveIconKey: 'colored-orange-circles',
  },
  {
    backgroundColor: '#F0CCCE',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#E7B2B6',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#E0999E',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#D87F85',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#D1666D',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#C84C54',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#C1333C',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#B91924',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
  {
    backgroundColor: '#B2000C',
    foregroundColor: '#FFFFFF',
    liveIconKey: 'colored-white-circles',
  },
];
